"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._AnalyticsS3BucketDestination = {
    type: "structure",
    required: ["Format", "Bucket"],
    members: {
        Format: {
            shape: {
                type: "string"
            }
        },
        BucketAccountId: {
            shape: {
                type: "string"
            }
        },
        Bucket: {
            shape: {
                type: "string"
            }
        },
        Prefix: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_AnalyticsS3BucketDestination.js.map